// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"e6ff0303","384":"e72646bd","782":"0d7aed9e"}[chunkId] + ".chunk.js";
};